import React from 'react'
import SubHeader from '../general/SubHeader'

const Contact = () => {
    return (
        <>
            <SubHeader message="Contact Us" />

            {/* Contact details section */}
            <section className='my-5'>
                <div className='container d-lg-flex d-md-flex d-block justify-content-center text-center'>

                    <div className='px-lg-5 px-4 py-4 border-right'>
                        <i className="fs-4 fa-regular fa-map text-muted"></i>
                        <p className='my-1 fw-semibold'>Address:</p>
                        <p className='text-muted'>Add the location here</p>
                    </div>

                    <div className='px-lg-5 px-4 py-4 border-right'>
                        <i className="fs-4 fa-solid fa-mobile-screen-button text-muted"></i>
                        <p className='my-1 fw-semibold'>Phone:</p>
                        <p className='text-muted'>+ 998 877 6543</p>
                    </div>

                    <div className='px-lg-5 px-4 py-4'>
                        <i className="fs-4 fa-regular fa-envelope text-muted"></i>
                        <p className='my-1 fw-semibold'>Email:</p>
                        <p className='text-muted'>sgroup@gmail.com</p>
                    </div>

                </div>
            </section>
            {/* Contact details section ends */}


            {/* Form Section */}
            <section className='my-5'>
                <div className='container text-center px-4'>

                    <p className='sec-subheading'><hr /><span>Have Questions in mind ?</span><hr /></p>
                    <p className='sec-heading'>Contact Now</p>


                    <form class="row g-3 bg-body-tertiary px-4 py-5 mt-4 col-lg-8 col-md-10 col-12 mx-auto text-start">
                        <div class="col-12">
                            <input type="text" class="form-input" id="inputText" placeholder='Your Name' />
                        </div>

                        <div class="col-12">
                            <input type="email" class="form-input" id="inputEmail" placeholder='Your Email' />
                        </div>
                        <div class="col-12">
                            <input type="tel" class="form-input" id="inputAddress" placeholder="Your Phone" />
                        </div>
                        <div class="col-12">
                            <textarea className='form-input' id="inputMessage" placeholder='Write Message Here' style={{ height: '10em' }}></textarea>
                        </div>
                        <div class="col-lg-3 col-12">
                            <button type="submit" class="banner-btn w-100">Send Message</button>
                        </div>
                    </form>
                    {/* form ends */}

                </div>
            </section>
            {/* Form Section ends */}


            {/* Map Section */}
            <section className='my-5'>
                <div className='container px-4'>

                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28842.05054129468!2d82.15176147431642!3d25.36272469999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398555df0e636aa3%3A0x85a9c468f03b08a2!2sDECTWIN%20SERVICES!5e0!3m2!1sen!2sin!4v1734506208434!5m2!1sen!2sin"
                        className='w-100 border-0' height="500" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

                </div>
            </section>
            {/* Map Section ends */}

        </>
    )
}

export default Contact
